import $ from "jquery";
import _ from "underscore";
import "bootstrap/js/dist/tooltip";
import Vue from "vue";
import Clipboard from "clipboard";

Vue.directive("numeric", {
    bind(el, binding) {
        $(el).on("input", event => {
            const defaultOptions = {
                allowDecimal: false
            };

            const options = $.extend(true, defaultOptions, binding.value || {});
           
            const input = event.target;

            const newValue = options.allowDecimal
                ? input.value.replace(/[^\d.]/g, "").replace(/^\.|(\..*)\./g, "$1") // Удаляем все символы, кроме цифр и точек, затем, точки в начале строки все точки после первой
                : input.value.replace(/\D/g, ""); // Удвляем все символы, кроме цифр

            if (newValue !== input.value) {
                input.value = newValue;
                input.dispatchEvent(new Event("input"));
            }            
        });
    },
    unbind(el) {
        $(el).off("input");
    }
});

Vue.directive("clipboard", {
    bind(el, binding, vNode) {
        const options = typeof binding.value === "function" ? { text: binding.value } : binding.value;
        const clipboard = new Clipboard(el, options);

        clipboard.on("success", () => {
            $(el).tooltip({
                placement: "bottom",
                trigger: "manual",
                title: vNode.context.$t("common.copied")
            });

            $(el).tooltip("show");

            setTimeout(() => {
                $(el).tooltip("dispose");
                $(el).attr("title", null);
            }, 1000);
        });
    },

    unbind(el) {
        const clipboard = new Clipboard(el);
        clipboard.destroy();
    }
});

Vue.directive("infinite-scroll", {
    bind(el, binding) {
        const scrollTargetSelector = binding.value.scrollSelector;
        const loadData = binding.value.loadData;
        const loadingDisabled = binding.value.loadingDisabled;

        const $element = $(el);
        const $scrollTarget = scrollTargetSelector !== undefined ? $(scrollTargetSelector) : $(window);

        const checkScroll = _.throttle(function () {
            if (loadingDisabled()) {
                return;
            }

            const bottom = $scrollTarget.scrollTop() + ($scrollTarget[0] === window ? window.innerHeight : $scrollTarget.height());
            const elTop = $element.position().top;
            if (bottom >= elTop) {
                loadData();
            }
        }, 200);

        $scrollTarget.on("scroll.infinite", checkScroll);
    },
    unbind(el, binding) {
        const scrollTargetSelector = binding.value;

        const $scrollTarget = scrollTargetSelector !== undefined ? $(scrollTargetSelector) : $(window);
        $scrollTarget.off("scroll.infinite");
    }
});

Vue.directive("sort-by-column", {
    bind(el, binding, vNode) {
        if (binding.value === null) {
            return;
        }

        let fieldFunction = null;

        if (binding.value.fieldFunction !== undefined) {
            fieldFunction = binding.value.fieldFunction;
        }

        if (binding.value.initialSorting !== undefined && vNode.context.sorting.fieldName === "") {
            const sorting = ("" + binding.value.initialSorting).toLowerCase();

            if (sorting === "asc" || sorting === "ascending") {
                vNode.context.changeSorting(binding.value.fieldName,
                    binding.value.fieldType,
                    fieldFunction);
            } else if (sorting === "desc" || sorting === "descending") {
                vNode.context.changeSorting(binding.value.fieldName,
                    binding.value.fieldType,
                    fieldFunction);
                vNode.context.changeSorting(binding.value.fieldName,
                    binding.value.fieldType,
                    fieldFunction);
            }
        }

        const sortingIcon = $("<i class='fa sort-by-column-icon' aria-hidden='true'></i>");

        if (vNode.context.sorting.fieldName === binding.value.fieldName) {
            $(sortingIcon).addClass("text-primary");

            if (vNode.context.sorting.isAscending) {
                $(sortingIcon).addClass("fa-sort-asc col-sort-asc");
            } else {
                $(sortingIcon).addClass("fa-sort-desc col-sort-desc");
            }
        } else {
            $(sortingIcon).addClass("fa-sort");
        }

        $(el).append(sortingIcon);

        $(el).addClass("sort-by-column");

        $(el).click(() => vNode.context.changeSorting(binding.value.fieldName,
            binding.value.fieldType,
            fieldFunction));
    },
    update(el, binding, vNode) {
        if (binding.value === null) {
            return;
        }

        const sortingIcon = $(el).children(".sort-by-column-icon").eq(0);

        if (vNode.context.sorting.fieldName === binding.value.fieldName) {
            if (vNode.context.sorting.isAscending) {
                sortingIcon.removeClass("fa-sort fa-sort-desc col-sort-desc");
                sortingIcon.addClass("fa-sort-asc col-sort-asc text-primary");
            } else {
                sortingIcon.removeClass("fa-sort fa-sort-asc col-sort-asc");
                sortingIcon.addClass("fa-sort-desc col-sort-desc text-primary");
            }
        } else {
            sortingIcon.removeClass("fa-sort-asc col-sort-asc text-primary fa-sort-desc col-sort-desc");
            sortingIcon.addClass("fa-sort");
        }
    }
});